import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoLoadTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoLoadTypeModel._instance == null) GeoLoadTypeModel._instance = new GeoLoadTypeModel(authManager);
        return GeoLoadTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-load-types', 'model-sections/geo-load-types/codelist');

        this.entityName = 'model-sections.GeoLoadType';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Load Type';
        this.setLabel = 'Load Types';

        this.browser = {
            name: 'default-model-sections-geoloadtype-browser',
            moduleName: 'default-model-sections-geoloadtype-browser',
            moduleTitle: 'Load Types',
            moduleStateSlotName: 'default-model-sections-geoloadtype-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoloadtype-editor',
            moduleName: 'default-model-sections-geoloadtype-editor',
            moduleTitle: 'Load Type',
            moduleStateSlotName: 'default-model-sections-geoloadtype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
